import type { SurfaceConfig } from "@/facets/config";
import type { FacetFiltersController } from "@/facets/use-facet-filters";

export function activeFacetFilterCount(
  surface: SurfaceConfig,
  controller: FacetFiltersController,
): number {
  return surface.facets.reduce((count, def) => {
    if (def.key === "format") return count;
    if (def.widget === "range") return count + Number(controller.getRange(def.key) !== null);
    return count + controller.getValues(def.key).length;
  }, 0);
}
